module.exports = __webpack_public_path__ + "img/3f_r_first@2x.efd1ac6b.jpg";